import { create } from 'zustand';

/** What any panel can ask of the dock: the workspace registers these once it exists. */
export interface WorkspaceActions {
  /** Shows the order ticket (opening it if it was closed), like F9. */
  orderTicket: () => void;
  /** Opens another chart; with a symbol it shows that symbol and does not follow Market Watch. */
  newChart: (symbol?: string) => void;
  /** Shows one of the workspace panels (the tick chart, say), opening it if it was closed. */
  showPanel?: (id: string) => void;
  /** Switches to a saved profile (the classic Navigator lists them). */
  applyProfile?: (name: string) => void;
  /** Opens the settings (where a demo account is opened, among others). */
  openSettings?: () => void;
}

interface WorkspaceState {
  /** The symbol the user is looking at: charts and the order ticket follow it. */
  activeSymbol: string | null;
  select: (symbol: string | null) => void;
  actions: WorkspaceActions | null;
  setActions: (actions: WorkspaceActions | null) => void;
}

export const useWorkspace = create<WorkspaceState>((set) => ({
  activeSymbol: null,
  select: (activeSymbol) => set({ activeSymbol }),
  actions: null,
  setActions: (actions) => set({ actions }),
}));
